import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import {
    Science as ScienceIcon, ForwardToInbox as ForwardToInboxIcon
} from '@mui/icons-material';

function SendoutIsTestChip({ is_test, ...params }) {
    const { t } = useTranslation();

    return is_test
        ? <Chip icon={<ScienceIcon />} label={t('Test mode')} size="small" {...params} />
        : <Chip icon={<ForwardToInboxIcon />} label={t('Real sendout')} size="small" {...params} />;
}

export default SendoutIsTestChip;